import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import * as React from 'react';
import { HeaderDropdown } from 'palette/HeaderDropdown';
import { SECONDARY_MENU_ID } from 'palette/HeaderDropdown/constants/menuIds';
import { IconName } from 'palette/Icon';
import './styles/SubHeaderDropdown.scss';

interface SubHeaderDropdownProps {
    isOpen: boolean;
    footerData: {
        iconName: IconName;
        label: string;
    }[];
    children: React.ReactNode;
    className?: string;
    v2?: boolean;
    ariaLabel?: string;
}

function SubHeaderDropdown({
    footerData,
    isOpen,
    children,
    className,
    v2 = false,
    ariaLabel,
}: SubHeaderDropdownProps) {
    const [block, BEMElement] = BEMBlock('sub-header-dropdown', { hidden: !isOpen });

    return (
        <HeaderDropdown
            ariaLabel={ariaLabel}
            className={block}
            footerData={footerData}
            id={SECONDARY_MENU_ID}
            isOpen={isOpen}
        >
            <div
                className={classNames(
                    BEMElement('container', { 'new-nav': v2 }),
                    className,
                )}
            >
                {children}
            </div>
        </HeaderDropdown>
    );
}

export default SubHeaderDropdown;
